import {
    TargetsAndGrid,
    RangeLineChart,
    StackedLineBarChart,
} from "@assets/beats/solutions";

export const metaDataHeader = { title: "", desc: "", img: "" };

export const latest = [
    {
        title: "London Climate Action Week event highlights innovation in policy and finance for tropical forests.",
        date: "07.09.25",
        link: "/news/event-recap-2025-lcaw",
    },
    {
        title: "CTrees presents on alerts for jurisdictional monitoring at AGU24",
        date: "12.11.24",
        link: "/news/AGU24",
    },
    {
        title: "CTrees hosts panel on jurisdictional finance at Climate Week NYC",
        date: "9.24.24",
        link: "/news/nycw2024-ctreespanel",
    },
];

export const hero = {
    title: "Carbon Markets",
    subheader:
        "Scientific data and insights to accelerate private investment in natural climate solutions",
    bgImg: "https://ctrees-website.s3.amazonaws.com/webv3/solutions/hero/carbon-markets.png",
    bgImgStyle: "h-screen object-cover",
    bgImgPosition: {
        mobile: " object-[12%]",
        tablet: " object-[-250px]",
        desktop: " object-[-20px]",
    },
};

const chartContainerStyle = "h-4/5 w-4/5 m-auto md:w-3/5";
export const firstBeat = {
    title: "Analyze projects",
    subheader:
        "<p>Monitor and report on nature-based carbon projects with science-backed CTrees data, compatible across methodologies. CTrees enables project developers and investors to:</p><br/><ul><li>Get rapid results for REDD+, ARR, and IFM projects in any ecosystem.</li><li>Access high-resolution maps of biomass to estimate emissions from deforestation, degradation, and removal from regeneration.</li><li>Track project performance at every stage: feasibility, issuance, and monitoring.</li></ul>",
    img: <RangeLineChart className={chartContainerStyle} />,
    customTextClass: "carbon-markets-text",
    buttonLink: "/solutions/project-analysis",
    buttonText: "Learn more",
};
export const secondBeat = {
    title: "Evaluate jurisdictional REDD+ programs",
    subheader:
        "<p>Access historical geospatial data to track and assess jurisdictional REDD+ performance under ART/TREES, Verra (VM0048), and VCS JNR frameworks. CTrees data platforms provide precise emission factors and activity data to support:</p><br/><ul><li>Establishing dynamic baselines and assessing additionality.</li><li>Estimating emissions, removals, and reliable carbon credit projections.</li><li>Monitoring leakage, reversals from fire, and other disturbances.</li></ul>",
    img: <TargetsAndGrid />,
    bg: "https://ctrees-website.s3.amazonaws.com/webv3/solutions/beats/carbon-markets.png",
    textRight: true,
    customTextClass: "carbon-markets-text",
};
export const thirdBeat = {
    title: "Innovate with methodologies",
    subheader:
        "<p>Partner with CTrees to shape the next generation of nature-based solutions. CTrees collaborates with carbon standards, nonprofits, and the private sector to:</p><br/><ul><li>Develop new standards and credit mechanisms for tropical forests.</li><li>Build digital MRV platforms for jurisdictional REDD+ investments.</li><li>Support tree-level management across U.S. natural and urban forests.</li></ul>",
    img: <StackedLineBarChart className={chartContainerStyle} />,
    customTextClass: "carbon-markets-text",
};

export const dataCards = [
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/LCAW25_Photo2.png",
        imgAlt: "",
        title: "Event recap: Delivering durable finance for tropical forests",
        subheader:
            "CTrees event at London Climate Action Week highlights innovations in policy and finance.",
        link: "/news/event-recap-2025-lcaw",
        linkDisplayText: "see more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/23_08+Verra+consolidated+REDD.jpg",
        imgAlt: "",
        title: "Providing data for Verra’s REDD+ methodology",
        subheader:
            "CTrees is providing jurisdictional data for the standard’s consolidated REDD+ methodology.",
        link: "/news/ctrees-verra-redd-data-14",
        linkDisplayText: "read more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/webv3/solutions/cards/25_04+NYCW.jpg",
        imgAlt: "",
        title: "Raising ambition for jurisdictional finance",
        subheader:
            "CTrees hosted Gov. Helder Barbalho and science and policy experts for a Climate Week NYC event on jurisdictional REDD",
        link: "/news/nycw2024-ctreespanel-41",
        linkDisplayText: "learn more",
    },
];

export const dataSubheader = "News, insights, and data for carbon markets";
